import { createSlice } from "@reduxjs/toolkit";
import { Toast } from "src/data/types";

export type LayoutState = {
  isSideMenuOpen: boolean;
  appToasts: Toast[];
};

const initialState: LayoutState = {
  isSideMenuOpen: false,
  appToasts: [],
};

/** Header Slice */
const { reducer, actions } = createSlice({
  name: "layoutSlice",
  initialState,
  reducers: {
    setIsSideMenuOpen: (state, { payload }) => {
      state.isSideMenuOpen = payload;
    },
    createToast: (state, { payload }) => {
      const newToast = { ...payload, id: String(Math.random()) };
      state.appToasts.push(newToast);
    },
    deleteToast: (state, { payload }) => {
      state.appToasts = state.appToasts.filter((toast) => toast.id !== payload);
    },
  },
});

export const { setIsSideMenuOpen, createToast, deleteToast } = actions;

export default reducer;
